import React from "react"
import { Modal } from "src/shared/components/layout/modal/Modal"
import Icon from "src/shared/icons"
import "./PuestosRoles.css"
import { PuestosRolesModalProps } from "./PuestosRoles.type"
import { FUNCIONES, ROLES } from "./PuestosRoles.constants"


const PuestosRoles = ({ isOpen, onClose }: PuestosRolesModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            maxWidth={1198}
            maxHeight="90vh"
            style={{ overflow: "hidden", display: "flex", flexDirection: "column", padding: 0 }}
        >
            <div className="puestosRoles">
                <div className="puestosRoles__header">
                    <h2 className="puestosRoles__title">Puestos o roles</h2>
                    <button className="puestosRoles__close" onClick={onClose} aria-label="Cerrar">
                        <Icon name="xclose" color="#303030" width={15} height={15} />
                    </button>
                </div>
                <div className="puestosRoles__table-wrapper">
                    <table className="puestosRoles__table">
                        <thead>
                            <tr>
                                <th className="puestosRoles__th puestosRoles__th--funcion">Función</th>
                                {ROLES.map((rol) => (
                                    <th key={rol} className="puestosRoles__th">
                                        {rol}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {FUNCIONES.map((funcion) => (
                                <tr key={funcion.nombre} className="puestosRoles__tr">
                                    <td className="puestosRoles__td puestosRoles__td--funcion">{funcion.nombre}</td>
                                    {funcion.acceso.map((tiene, i) => (
                                        <td key={i} className="puestosRoles__td puestosRoles__td--check">
                                            {tiene ? (
                                                <span className="puestosRoles__check">
                                                    <Icon name="check" color="white" width={12} height={12} />
                                                </span>
                                            ) : (
                                                <span className="puestosRoles__dash">-</span>
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Modal>
    )
}

export default PuestosRoles
